import { ICourse } from "store/StateInterfaces";

export default function coursesListToMap(coursesList: ICourse[]) {
    let coursesMap = new Map<number, ICourse>();
    coursesList.forEach((course) => {
        coursesMap.set(course.id, course);
    });
    return coursesMap;
};

